<template>
  <div>
    <div class="footer__social--link">
      <p-link
        v-for="(guide, index) in guides"
        :key="`paribuLinks-${index}`"
        size="md"
        target="_blank"
        :label="guide.name"
        :href="guide.link"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const guides = [
  {
    name: 'Paribu Self',
    link: 'https://www.paribu.com/self/',
  },
  {
    name: 'Paribu Custody',
    link: 'https://paribucustody.com/',
  },
  {
    name: 'Paribu Stock',
    link: 'https://www.paribu.com/',
  },
  /* {
    name: 'Paribu Money',
    link: '/money',
  },
  {
    name: 'Paribu Pass',
    link: '/pass',
  }, */
  {
    name: 'ParibuLog',
    link: 'https://www.paribu.com/blog/',
  },
  {
    name: 'ParibuHub',
    link: 'https://www.paribu.com/hub/',
  },
  {
    name: 'Team Paribu',
    link: 'https://team.paribu.com/',
  },
  {
    name: 'P-Games',
    link: 'https://www.p-games.io/',
  },
  {
    name: 'Paribu Ventures',
    link: 'https://ventures.paribu.com/',
  },
  {
    name: 'Paribu Art',
    link: 'https://art.paribu.com/',
  },
]
</script>
